(function initializePersonalizationLoading() {
  const placeholder = document.querySelector('.gp-personalize-loading');
  if (!placeholder) return;
  const scope = placeholder.closest('product-info') || placeholder.closest('.shopify-section');
  if (!scope) return;
  const campaign = window.teeinblueCampaign;
  if (campaign?.isPlatformProduct) {
    placeholder.hidden = true;
    scope.classList.remove('gp-personalize-pending');
    return;
  }
  // Customizer products start pending in Liquid, before the app or its
  // campaign request loads. Other products keep their native controls.
  if (!scope.classList.contains('gp-personalize-pending') && !campaign?.isTeeInBlueProduct) {
    document.addEventListener('gp:personalization-verified', initializePersonalizationLoading, { once: true });
    return;
  }
  if (scope.dataset.personalizationLoadingInitialized) return;
  scope.dataset.personalizationLoadingInitialized = 'true';
  let frame;
  let timer;
  let finished = false;
  const message = placeholder.querySelector('.gp-personalize-loading__message');
  const retry = placeholder.querySelector('button');
  retry.addEventListener('click', () => location.reload());
  placeholder.hidden = false;
  scope.classList.add('gp-personalize-pending');

  function inspect() {
    frame = null;
    const inputs = scope.querySelector('#teeFormInputs');
    // Teeinblue builds the fields asynchronously. A campaign event alone is not readiness.
    const fieldsReady = inputs?.querySelector('input:not([type="hidden"]), select, textarea, .tee-field');
    const actionsReady = scope.querySelector('#teeFormActions button');
    if (!fieldsReady || !actionsReady) return;
    finished = true;
    clearTimeout(timer);
    observer.disconnect();
    placeholder.hidden = true;
    scope.classList.remove('gp-personalize-pending');
    scope.classList.add('gp-personalize-ready');
    document.removeEventListener('teeinblue-event-component-injected', schedule);
    document.removeEventListener('teeinblue-event-campaign-loaded', schedule);
  }
  function schedule() {
    if (!finished && !frame) frame = requestAnimationFrame(inspect);
  }
  const observer = new MutationObserver(schedule);
  observer.observe(scope, { childList: true, subtree: true });
  document.addEventListener('teeinblue-event-component-injected', schedule);
  document.addEventListener('teeinblue-event-campaign-loaded', schedule);
  timer = setTimeout(() => {
    if (finished) return;
    placeholder.classList.add('is-slow');
    message.textContent = 'The personalized form is taking longer than expected.';
    retry.hidden = false;
    // Continue listening: a late response can still reveal the form without a reload.
  }, 20000);
  inspect();
})();
